export default __webpack_public_path__ + "static/media/ShipNA.0cd2c10d.png";